import { getAppConfiguration } from "../../../Config";
import { interceptFetch } from "../../InterceptFetch";
import { AuthHeaders } from "../Component/authHeader";
import { ALL_GROUPS,ASSIGN_DOCUMENT_GROUP,CREATE_GROUP_DOCUMENTS, CUSTOMER, DELETE_GROUPS, DOCUMENT_GROUP, DOCUMENT_GROUP_HIERARCHICAL, DOCUMENT_GROUPS, GET_BY_ID_DOCUMENT_GROUP, GET_CUSTOMER, PERMISSION, PERMISSION_DOCUMENT_GROUP, PERMISSIONS, UPDATE_DOCUMENT_GROUP, USER_DELETE, USER_GROUP} from "../Component/EndPointServices";
const mlsApiLocal = getAppConfiguration().mlsApiUrl;
class DocumentGroupHelperServices {
    CREATE_DOCUMENTS_GROUP = async(groupParam:any,accessToken:any) => {
        let customerId = groupParam?.customerId;
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(groupParam),headers: headers};
        try{
        const createGroup =  await interceptFetch(mlsApiLocal+CUSTOMER+customerId+DOCUMENT_GROUP,options).catch(err=>{console.log("the error douments group  ==>",err)});
        return createGroup;
        }catch(error){console.log(error," douments group error helper")}
    };
    ALL_DOCUMENTS_GROUP = async(customerId:number, accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        let api;
        if(customerId != 0 && customerId != undefined && customerId != null)
        api = mlsApiLocal+CUSTOMER+customerId+DOCUMENT_GROUPS;
        else
        api = mlsApiLocal+CUSTOMER;
        const allUsersGroup =  await interceptFetch(api,options).catch(err=>{console.log("the error all document group  ==>",err)});
        return allUsersGroup;
        }catch(error){console.log(error,"documents group error helper")}
    };
    DELETE_DOCUMENTS_GROUP = async(userGroupId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
        try{
        const deleteGroup =  await interceptFetch(mlsApiLocal+DELETE_GROUPS+userGroupId,options).catch(err=>{console.log("the delete error document group  ==>",err)});
        return deleteGroup;
        }catch(error){console.log(error,"delete document group error helper")}
    };
    GET_ID_BY_DOCUMENTS_GROUP = async(groupId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const getIdBy =  await interceptFetch(mlsApiLocal+GET_BY_ID_DOCUMENT_GROUP+groupId,options).catch(err=>{console.log("the error get by id document group  ==>",err)});
        return getIdBy;
        }catch(error){console.log(error,"get by id document group error helper")}
    };
    ASSIGN_GROUP_ADD_DOCUMENT = async(userGroup:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "PUT",body:JSON.stringify(userGroup),headers: headers};
        try{
        const formGroupAdd =  await interceptFetch(mlsApiLocal+ASSIGN_DOCUMENT_GROUP,options).catch(err=>{console.log("the error form document group  ==>",err)});
        return formGroupAdd;
        }catch(error){console.log(error,"form document group  error helper")}
    };
    PERMISSION_GROUP = async(permissionGroup:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(permissionGroup),headers: headers};
        try{
        const permission_group =  await interceptFetch(mlsApiLocal+PERMISSION,options).catch(err=>{console.log("the error permission group  ==>",err)});
        return permission_group;
        }catch(error){console.log(error,"permission group  error helper")}
    };
    GROUP_DOCUMENT_PERMISSION = async(permissionGroup:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "POST",body:JSON.stringify(permissionGroup),headers: headers};
        try{
        const permission_document =  await interceptFetch(mlsApiLocal+PERMISSION_DOCUMENT_GROUP,options).catch(err=>{console.log("the error permission document group  ==>",err)});
        return permission_document;
        }catch(error){console.log(error,"permission document group  error helper")}
    };
    DELETE_PERMISSION_USER = async(permissionId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
        try{
        const permission_user_document =  await interceptFetch(mlsApiLocal+PERMISSIONS+permissionId+USER_DELETE,options).catch(err=>{console.log("the error permission document user delete  ==>",err)});
        return permission_user_document;
        }catch(error){console.log(error,"permission document user delete  error helper")}
    };
    DELETE_PERMISSION_USER_GROUP = async(permissionId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "DELETE",headers: headers};
        try{
        const permission_group_delete =  await interceptFetch(mlsApiLocal+PERMISSIONS+permissionId+USER_GROUP,options).catch(err=>{console.log("the error permission user group delete  ==>",err)});
        return permission_group_delete;
        }catch(error){console.log(error,"permission user group delete  error helper")}
    };
    UPDATE_DOCUMENTS_GROUP = async(groupParam:any,documentGroupId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "PUT",body:JSON.stringify(groupParam),headers: headers};
        try{
        const updateGroup =  await interceptFetch(mlsApiLocal+UPDATE_DOCUMENT_GROUP+documentGroupId,options).catch(err=>{console.log("the error update document group  ==>",err)});
        return updateGroup;
        }catch(error){console.log(error,"update document group error helper")}
    };
    HIERARCHICAL_DOCUMENTS_GROUP= async(customerId:any,accessToken:any) => {
        const headers = AuthHeaders(accessToken);
        const options = {method: "GET",headers: headers};
        try{
        const hiararichcalGroup =  await interceptFetch(mlsApiLocal+GET_CUSTOMER+customerId+DOCUMENT_GROUP_HIERARCHICAL,options).catch(err=>{console.log("the error heirarchcal document group  ==>",err)});
        return hiararichcalGroup;
        }catch(error){console.log(error,"heirarchcal document group error helper")}
    };
}
export default new DocumentGroupHelperServices();